import baseLayout from "../layout/BaseLayout.vue"
import baseThemeLayout from "../layout/BaseThemeLayout.vue"

import notFound from "../pages/NotFound.vue"
import form from "../pages/form/Form.vue"
import externalForm from "../pages/externalForm/Form.vue"
import customPage from "../pages/customPage/CustomPage.vue"
import gird from "../pages/grid/Grid.vue"
import chart from "../pages/Chart.vue"
import login from "../pages/login/Login.vue"
import netWorkError from "../pages/NetWorkError.vue"
import welCome from "../pages/WelCome.vue"
import unAuthoized from "../pages/UnAuthoized.vue"
import adminLayout from "../layout/AdminLayout.vue"

import { createRouter,createWebHashHistory } from "vue-router"
import { RouterMeta } from "."
import { afterToNext, beforeToNext } from "./routeAssist"
import todoTask from "../components/FlowTask/Task.vue"
import { TaskType } from "../components/FlowTask"

const routes = [
    {
        name: RouterMeta.index.name,
        path: RouterMeta.index.path,
        component: adminLayout,
        meta:{ 
            name: RouterMeta.index.name,
            isAuth:true
        },
        children: [
            {
                name: '1',
                path: '', 
                component: welCome
            }
        ]
    },
    {
        name: RouterMeta.todoTask.name,
        path: RouterMeta.todoTask.path,
        component: adminLayout,
        meta:{ 
            name: RouterMeta.todoTask.name,
            isAuth:true
        },
        children: [
            {
                name: '2',
                path: '', 
                component: todoTask,
                props: () => ({
                    taskType: TaskType.ToDoTask
                })
            }
        ]
    },
    {
        name: RouterMeta.ownerTask.name,
        path: RouterMeta.ownerTask.path,
        component: adminLayout,
        meta:{ 
            name: RouterMeta.ownerTask.name,
            isAuth:true
        },
        children: [
            {
                name: '3',
                path: '', 
                component: todoTask,
                props: () => ({
                    taskType: TaskType.OwnerTask 
                })
            }
        ]
    },
    {
        name: RouterMeta.participateTask.name,
        path: RouterMeta.participateTask.path,
        component: adminLayout,
        meta:{ 
            name: RouterMeta.participateTask.name,
            isAuth:true
        },
        children: [
            {
                name: '4',
                path: '', 
                component: todoTask,
                props: () => ({
                    taskType: TaskType.ParticipateTask 
                })
            }
        ]
    },
    {
        name: RouterMeta.cCTask.name,
        path: RouterMeta.cCTask.path,
        component: adminLayout,
        meta:{ 
            name: RouterMeta.cCTask.name,
            isAuth:true
        },
        children: [
            {
                name: '5',
                path: '', 
                component: todoTask,
                props: () => ({
                    taskType: TaskType.CCTask 
                })
            }
        ]
    },
    {
        name: RouterMeta.notFound.name,
        path: RouterMeta.notFound.path,
        component: adminLayout,
        meta:{ 
            name: RouterMeta.notFound.name,
            isAuth:true
        },
        children: [
            {
                name: '6',
                path: '', 
                component: notFound
            }
        ]
    },
    {
        name: RouterMeta.login.name,
        path: RouterMeta.login.path,
        meta:{ 
            name: RouterMeta.login.name,
            isAuth:false 
        },
        component: login
    },
    {
        name: RouterMeta.grid.name,
        path: RouterMeta.grid.path,
        component: adminLayout,
        meta:{ 
            name: RouterMeta.grid.name,
            isAuth:true  
        },
        children: [
            {
                name: '7',
                path: '', 
                component: gird
            }
        ]
    },
    {
        name: RouterMeta.chart.name,
        path: RouterMeta.chart.path,
        component: adminLayout,
        meta:{ 
            name: RouterMeta.chart.name,
            isAuth:true  
        },
        children: [
            {
                name: '8',
                path: '', 
                component: chart
            }
        ]
    },
    {
        name: RouterMeta.customPage.name,
        path: RouterMeta.customPage.path,
        component: adminLayout,
        meta:{ 
            name: RouterMeta.customPage.name,
            isAuth:true  
        },
        children: [
            {
                name: '9',
                path: '', 
                component: customPage
            }
        ]
    },
    {
        name: RouterMeta.fullScreenCustomPage.name,
        path: RouterMeta.fullScreenCustomPage.path,
        component: baseLayout,
        meta:{ 
            name: RouterMeta.fullScreenCustomPage.name,
            isAuth:true  
        },
        children: [
            {
                name: '10',
                path: '', 
                component: customPage
            }
        ]
    },
    {
        name: RouterMeta.form.name,
        path:  RouterMeta.form.path,
        component: adminLayout,
        meta:{ 
            name: RouterMeta.form.name,
            isAuth:true  
        },
        children: [
            {
                name: '11',
                path: '', 
                component: form
            }
        ]
    },
    {
        name: RouterMeta.externalForm.name,
        path: RouterMeta.externalForm.path,
        component: baseThemeLayout,
        meta:{ 
            name: RouterMeta.externalForm.name,
            isAuth:false  
        },
        children: [
            {
                name: '12',
                path: '', 
                component: externalForm
            }
        ]
    },
    {
        name: RouterMeta.netWorkError.name,
        path: RouterMeta.netWorkError.path,
        component: adminLayout,
        meta:{ 
            name: RouterMeta.netWorkError.name,
            isAuth:false  
        },
        children: [
            {
                name: '13',
                path: '', 
                component: netWorkError
            }
        ]
    },
    {
        name: RouterMeta.unAuthoized.name,
        path: RouterMeta.unAuthoized.path,
        component: adminLayout,
        meta:{ 
            name: RouterMeta.unAuthoized.name,
            isAuth:false  
        },
        children: [
            {
                name: '14',
                path: '', 
                component: unAuthoized
            }
        ]
    },
    {
        path:'/:pathMatch(.*)*',
        component: adminLayout,
        children: [
            {
                name: '15',
                path: '', 
                component: notFound
            }
        ]
    },
    {
        name: RouterMeta.baseNetWorkError.name,
        path: RouterMeta.baseNetWorkError.path,
        component: baseLayout,
        meta:{ name: RouterMeta.baseNetWorkError.name },
        children: [
            {
                name: '16',
                path: '', 
                component: netWorkError
            }
        ]
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes, 
})

router.beforeEach(async (to, from) => {
    let routerResult = await beforeToNext(to);
    return routerResult;
})

router.afterEach((to, from) => {
    afterToNext(to)
})

export default router


